import LinkWithSVG from "@/components/links/LinkWithSVG/LinkWithSVG";
import styles from "./MenuLeft.module.css";
//logo icon
import Logo from "@/assets/icons/common/logo-header.svg?react";
import { useStoreMenu } from "@/hooks/Menu/useStoreMenu";
import { Counter } from "./Counter";
import { SettingButton } from "./SettingButton/SettingButton";

export const MenuLeft = () => {
  const {
    refArrow,
    defaultWidth,
    activePath,
    firstLoad,
    refMenu,
    handleMouseEnter,
    handleMouseLeave,
    handleLinkClick,
    links,
  } = useStoreMenu();

  return (
    <div
      style={{ width: defaultWidth }}
      className={styles.menu}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Counter />
      <div className={styles.navDiv} ref={refMenu} style={{ width: defaultWidth }}>
        <Logo className={styles.logo} />
        <nav>
          <div>
            {links.map((link) => {
              if (link.path !== "/adminPanel") {
                let counter;
                if (link.path === "/reviews") {
                  counter = (
                    <div
                      id="counters"
                      className="absolute w-1 h-1 penter-events-none right-0 top-1/2 -translate-y-1/2"
                    ></div>
                  );
                }
                return (
                  <LinkWithSVG
                    key={link.path}
                    path={link.path}
                    svg={link.icon}
                    additional={counter}
                    click={(el: HTMLAnchorElement, e: React.MouseEvent) => handleLinkClick(link.path, el, e)}
                    className={activePath === link.path ? styles.active : ""}
                  >
                    {link.label}
                  </LinkWithSVG>
                );
              }
            })}
          </div>

          <section>
            {links.map((link) => {
              if (link.path === "/adminPanel") {
                return (
                  <LinkWithSVG
                    key={link.path}
                    path={link.path}
                    svg={link.icon}
                    click={(el: HTMLAnchorElement, e: React.MouseEvent) => handleLinkClick(link.path, el, e)}
                    className={activePath === link.path ? styles.active : ""}
                  >
                    {link.label}
                  </LinkWithSVG>
                );
              }
            })}
            <SettingButton />
          </section>
        </nav>
      </div>

      <div data-first-load={firstLoad} ref={refArrow} className={styles.arrow}></div>
    </div>
  );
};
